module.exports = __webpack_public_path__ + "static/media/itsuki_top1b349affc50eedfb5695084ee6d54877.webp";